export { default } from './table-cell';
export * from '@mui/material/TableCell';
